import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../../../utils/misc/auto-unsubscribe';
import { OnDestroyComponent } from '../../../../shared/components/on-destroy/on-destroy.component';

@Component({
  selector: 'app-kaza-edit-postal-code',
  templateUrl: './kaza-edit-postal-code.component.html'
})
@AutoUnsubscribe([])
export class KazaEditPostalCodeComponent extends OnDestroyComponent implements OnInit, AfterViewInit {
  @Input() kazaForm: UntypedFormGroup;
  @Input() postalCode: string;
  @Input() isRequired = false;

  private subscriptionKazaFormCountryGet: Subscription;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.countryOnChanges();
  }

  initForm(): void {
    this.kazaForm.addControl('postalCode', new UntypedFormControl(this.postalCode, [Validators.required, this.postalCodeValidator]));
  }

  postalCodeValidator(c: UntypedFormControl) {
      const validPostalCode = /^[0-9]{5}$/i;
      let country;
      const group = c.parent;

      if (group) {
          country = group.controls[`country`].value;

          if (('FR' !== country && '' !== c.value) || ('FR' === country && validPostalCode.test(c.value))) {
              return null;
          }
      }

      return { postalCodeValidError: {value: true}};
  }

  countryOnChanges(): void {
    this.subscriptionKazaFormCountryGet = this.kazaForm.get('country').valueChanges.subscribe(
      data => {
        if (data !== 'FR') {
          this.isRequired = false;
          this.kazaForm.get('postalCode').setValidators(null);
        } else {
          this.isRequired = true;
          this.kazaForm.get('postalCode').setValidators([Validators.required, this.postalCodeValidator]);
        }
        this.kazaForm.get('postalCode').updateValueAndValidity();
      });
  }
}
